// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 공통 모달 스타일 - 데스크탑 디자인 (group-268 / rectangle-718) */
.logout-modal-overlay,
.logout-modal-overlay * {
    box-sizing: border-box;
}

.logout-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1002;
}

/* rectangle-718: 861×306, white */
.logout-modal-content {
    position: relative;
    background: var(--white, #ffffff);
    width: 861px;
    min-height: 306px;
    padding: 59px 68px 36px 68px;
    max-width: 90%;
    text-align: center;
}

.logout-modal-body {
    position: relative;
    text-align: left;
}

/* div4: 제목 - 28px, SemiBold, 중앙 */
.logout-modal-body h2 {
    color: var(--darkgrey3, #000000);
    font-family: "Inter", "Inter-SemiBold", sans-serif;
    font-size: 28px;
    font-weight: 600;
    margin: 0 0 20px 0;
    text-align: left;
}

.logout-modal-title-row {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 20px;
}

.logout-modal-title-row h2 {
    margin: 0;
    text-align: center;
}

/* 제목 행 좌측 정렬 */
.logout-modal-title-row.title-left {
    justify-content: flex-start;
}

.logout-modal-title-row.title-left h2 {
    text-align: left;
}

.logout-modal-title-row .close-btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: #999;
    padding: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.logout-modal-title-row .close-btn:hover {
    color: #333;
}

/* div3: 본문 - 18px, Regular, 좌측 정렬 */
.logout-modal-body p {
    color: var(--darkgrey3, #000000);
    font-family: "Inter", "Inter-Regular", sans-serif;
    font-size: 18px;
    font-weight: 400;
    margin: 0;
    text-align: left;
}

/* 푸터: 취소(btn2) + 확인(btn) */
.logout-modal-footer {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 17px;
}

.logout-modal-footer.footer-center {
    justify-content: right;
}

.logout-modal-footer.footer-right {
    justify-content: flex-end;
}

.logout-modal-footer.footer-left {
    justify-content: flex-start;
}

.logout-modal-footer button,
.logout-modal-footer a {
    height: 53px;
    font-family: "Inter", "Inter-Bold", sans-serif;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

/* btn2: 취소 - 215×53, black bg, white text, radius 5px */
.btn-cancel {
    background: var(--darkgrey3, #000000);
    color: var(--white, #ffffff);
    border: none;
    border-radius: 5px;
    width: 215px;
}

/* btn: 확인 - 194×53, white bg, black text, border */
.btn-confirm {
    background: var(--white, #ffffff);
    color: var(--darkgrey3, #000000);
    border: 1px solid var(--darkgrey3, #000000);
    border-radius: 0;
    width: 194px;
}

.btn-confirm:hover {
    background: #f5f5f5;
}

/* Mobile */
@media (max-width: 768px) {
    .logout-modal-content {
        width: 90%;
        min-height: auto;
        padding: 40px 24px 32px 24px;
    }

    .logout-modal-body h2,
    .logout-modal-title-row h2 {
        font-size: 22px;
    }

    .logout-modal-body p {
        font-size: 16px;
    }

    .logout-modal-footer {
        flex-direction: column;
        margin-top: 30px;
        gap: 12px;
    }

    .logout-modal-footer button,
    .logout-modal-footer a {
        width: 100%;
        max-width: 215px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Modal.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,gCAAgC;IAChC,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA,oCAAoC;AACpC;IACI,gCAAgC;IAChC,iDAAiD;IACjD,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,YAAY;IACZ,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA,wDAAwD;AACxD;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA,mDAAmD;AACnD;IACI,iCAAiC;IACjC,gCAAgC;IAChC,2CAA2C;IAC3C,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,4BAA4B;IAChC;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,SAAS;IACb;;IAEA;;QAEI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":["/* 공통 모달 스타일 - 데스크탑 디자인 (group-268 / rectangle-718) */\n.logout-modal-overlay,\n.logout-modal-overlay * {\n    box-sizing: border-box;\n}\n\n.logout-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1002;\n}\n\n/* rectangle-718: 861×306, white */\n.logout-modal-content {\n    position: relative;\n    background: var(--white, #ffffff);\n    width: 861px;\n    min-height: 306px;\n    padding: 59px 68px 36px 68px;\n    max-width: 90%;\n    text-align: center;\n}\n\n.logout-modal-body {\n    position: relative;\n    text-align: left;\n}\n\n/* div4: 제목 - 28px, SemiBold, 중앙 */\n.logout-modal-body h2 {\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter\", \"Inter-SemiBold\", sans-serif;\n    font-size: 28px;\n    font-weight: 600;\n    margin: 0 0 20px 0;\n    text-align: left;\n}\n\n.logout-modal-title-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.logout-modal-title-row h2 {\n    margin: 0;\n    text-align: center;\n}\n\n/* 제목 행 좌측 정렬 */\n.logout-modal-title-row.title-left {\n    justify-content: flex-start;\n}\n\n.logout-modal-title-row.title-left h2 {\n    text-align: left;\n}\n\n.logout-modal-title-row .close-btn {\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    font-size: 28px;\n    cursor: pointer;\n    color: #999;\n    padding: 0;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n.logout-modal-title-row .close-btn:hover {\n    color: #333;\n}\n\n/* div3: 본문 - 18px, Regular, 좌측 정렬 */\n.logout-modal-body p {\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter\", \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    font-weight: 400;\n    margin: 0;\n    text-align: left;\n}\n\n/* 푸터: 취소(btn2) + 확인(btn) */\n.logout-modal-footer {\n    margin-top: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 17px;\n}\n\n.logout-modal-footer.footer-center {\n    justify-content: right;\n}\n\n.logout-modal-footer.footer-right {\n    justify-content: flex-end;\n}\n\n.logout-modal-footer.footer-left {\n    justify-content: flex-start;\n}\n\n.logout-modal-footer button,\n.logout-modal-footer a {\n    height: 53px;\n    font-family: \"Inter\", \"Inter-Bold\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n    cursor: pointer;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n}\n\n/* btn2: 취소 - 215×53, black bg, white text, radius 5px */\n.btn-cancel {\n    background: var(--darkgrey3, #000000);\n    color: var(--white, #ffffff);\n    border: none;\n    border-radius: 5px;\n    width: 215px;\n}\n\n/* btn: 확인 - 194×53, white bg, black text, border */\n.btn-confirm {\n    background: var(--white, #ffffff);\n    color: var(--darkgrey3, #000000);\n    border: 1px solid var(--darkgrey3, #000000);\n    border-radius: 0;\n    width: 194px;\n}\n\n.btn-confirm:hover {\n    background: #f5f5f5;\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n    .logout-modal-content {\n        width: 90%;\n        min-height: auto;\n        padding: 40px 24px 32px 24px;\n    }\n\n    .logout-modal-body h2,\n    .logout-modal-title-row h2 {\n        font-size: 22px;\n    }\n\n    .logout-modal-body p {\n        font-size: 16px;\n    }\n\n    .logout-modal-footer {\n        flex-direction: column;\n        margin-top: 30px;\n        gap: 12px;\n    }\n\n    .logout-modal-footer button,\n    .logout-modal-footer a {\n        width: 100%;\n        max-width: 215px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
